import { Plus, Search } from "lucide-react";
import { SearchBarProps } from "./type";
import { useNavigate } from "react-router-dom";

export const SearchBar: React.FC<SearchBarProps> = ({
  searchTerm,
  onSearch,
}) => {
  const navigate = useNavigate();
  function onNewAudience() {
    navigate("/audience/new");
  }

  return (
    <div className="flex justify-between items-center gap-4 mb-6">
      <div className="relative flex-1 max-w-md">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
        <input
          type="text"
          placeholder="Search audiences"
          value={searchTerm}
          onChange={(e) => onSearch(e.target.value)}
          className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none"
        />
      </div>
      <button
        onClick={onNewAudience}
        className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-3 rounded-lg font-medium transition-colors"
      >
        <Plus className="w-4 h-4" />
        New Audience
      </button>
    </div>
  );
};
